import { cachedUrl } from '../../lib/storageUrl'

// Renders a post's photos. One photo → a square (1:1) frame. Multiple photos →
// either a tiled grid (default) or a horizontal swipe carousel, per the post's
// photo_layout. onOpen(i) opens the fullscreen viewer at that index.
export default function PostPhotos({
  urls,
  layout,
  onOpen,
}: {
  urls: string[]
  layout?: 'grid' | 'scroll' | null
  onOpen: (index: number) => void
}) {
  const list = (urls || []).filter(Boolean)
  if (list.length === 0) return null

  const imgStyle = { objectFit: 'cover' as const, aspectRatio: '1 / 1', transform: 'translateZ(0)' }

  // Single photo — consistent square frame
  if (list.length === 1) {
    return (
      <button onClick={() => onOpen(0)} className="w-full overflow-hidden rounded-sm block">
        <img loading="lazy" decoding="async" src={cachedUrl(list[0])} alt="" className="w-full" style={imgStyle} />
      </button>
    )
  }

  // Multiple photos — swipe carousel
  if (layout === 'scroll') {
    return (
      <div className="flex overflow-x-auto scrollbar-hide snap-x snap-mandatory gap-1 rounded-sm">
        {list.map((url, i) => (
          <button
            key={i}
            onClick={() => onOpen(i)}
            className="snap-center shrink-0 w-full overflow-hidden"
          >
            <img loading="lazy" decoding="async" src={cachedUrl(url)} alt="" className="w-full" style={imgStyle} />
          </button>
        ))}
      </div>
    )
  }

  // Multiple photos — tiled grid (default)
  return (
    <div
      className="grid gap-0.5"
      style={{ gridTemplateColumns: list.length === 3 ? '1fr 1fr 1fr' : '1fr 1fr' }}
    >
      {list.map((url, i) => (
        <button key={i} onClick={() => onOpen(i)} className="w-full overflow-hidden rounded-sm">
          <img
            loading="lazy"
            decoding="async"
            src={cachedUrl(url)}
            alt=""
            className="w-full"
            style={{ objectFit: 'cover', height: 200, transform: 'translateZ(0)' }}
          />
        </button>
      ))}
    </div>
  )
}
